import { render, staticRenderFns } from "./CompanyCardBasicData.vue?vue&type=template&id=3b048fe5&scoped=true&"
import script from "./CompanyCardBasicData.vue?vue&type=script&lang=ts&"
export * from "./CompanyCardBasicData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b048fe5",
  null
  
)

export default component.exports